import React from 'react';
import {
  Box,
  VStack,
  Text,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

export const ExamClosedMessage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      testID="mcq-exam-closed-screen"
      flex={1}
      justifyContent="center"
      alignItems="center"
      p="$6"
    >
      <VStack space="md" alignItems="center">
        <Text size="xl" bold textAlign="center" color="$textSubtle">
          {t('student.mcq.examClosedTitle')}
        </Text>
        <Text color="$textSubtle" textAlign="center">
          {t('student.mcq.examClosedBody')}
        </Text>
      </VStack>
    </Box>
  );
};

export default ExamClosedMessage;
